// @ts-strict-ignore
import * as React from 'react';
import { PropertyType } from 'common/report/constants';
import { AnalysisType, ChartPlotStyle, ChartType, FunnelOrder, FUNNELS_MATH_TYPES, InsightsResourceType, MetricType, ValueRepresentationType } from 'common/types/reports/bookmark';
import { CardSnabbdom } from '../chart-card';
const OVERALL = [{
  count: 45244,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 1,
  step_conv_ratio: 1
}, {
  count: 24994,
  avg_time: 175756,
  avg_time_from_start: 175756,
  overall_conv_ratio: 0.5524268411281054,
  step_conv_ratio: 0.5524268411281054,
  p_value: {
    insufficient_samples: false,
    p: 1,
    confidence: 0,
    is_interesting: false
  }
}, {
  count: 21760,
  avg_time: 84369,
  avg_time_from_start: 238643,
  overall_conv_ratio: 0.48094774997789763,
  step_conv_ratio: 0.8706089461470753,
  p_value: {
    insufficient_samples: false,
    p: 1,
    confidence: 0,
    is_interesting: false
  }
}, {
  count: 15159,
  avg_time: 238126,
  avg_time_from_start: 448583,
  overall_conv_ratio: 0.33504995137476795,
  step_conv_ratio: 0.6966452205882353,
  p_value: {
    insufficient_samples: false,
    p: 1,
    confidence: 0,
    is_interesting: false
  }
}];
const SERIES = [[{
  count: 44491,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 1,
  step_conv_ratio: 1
}, {
  count: 24781,
  avg_time: 175495,
  avg_time_from_start: 175495,
  overall_conv_ratio: 0.5569890539659706,
  step_conv_ratio: 0.5569890539659706,
  p_value: {
    insufficient_samples: false,
    p: 0,
    confidence: 1,
    is_interesting: true
  }
}, {
  count: 21591,
  avg_time: 83978,
  avg_time_from_start: 238132,
  overall_conv_ratio: 0.48528915960531344,
  step_conv_ratio: 0.8712723457487591,
  p_value: {
    insufficient_samples: false,
    p: 0,
    confidence: 1,
    is_interesting: true
  }
}, {
  count: 15131,
  avg_time: 237957,
  avg_time_from_start: 447856,
  overall_conv_ratio: 0.34009125441100446,
  step_conv_ratio: 0.7008012597841693,
  p_value: {
    insufficient_samples: false,
    p: 0,
    confidence: 1,
    is_interesting: true
  }
}], [{
  count: 1519,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 1,
  step_conv_ratio: 1
}, {
  count: 948,
  avg_time: 63693,
  avg_time_from_start: 63693,
  overall_conv_ratio: 0.6240947992100065,
  step_conv_ratio: 0.6240947992100065,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}, {
  count: 884,
  avg_time: 39736,
  avg_time_from_start: 88938,
  overall_conv_ratio: 0.5819618169848585,
  step_conv_ratio: 0.9324894514767933,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}, {
  count: 617,
  avg_time: 94761,
  avg_time_from_start: 147230,
  overall_conv_ratio: 0.40618828176431865,
  step_conv_ratio: 0.6979638009049773,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}], [{
  count: 1519,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 1,
  step_conv_ratio: 1
}, {
  count: 623,
  avg_time: 63693,
  avg_time_from_start: 63693,
  overall_conv_ratio: 0.6240947992100065,
  step_conv_ratio: 0.6240947992100065,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}, {
  count: 322,
  avg_time: 39736,
  avg_time_from_start: 88938,
  overall_conv_ratio: 0.5819618169848585,
  step_conv_ratio: 0.9324894514767933,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}, {
  count: 123,
  avg_time: 94761,
  avg_time_from_start: 147230,
  overall_conv_ratio: 0.40618828176431865,
  step_conv_ratio: 0.6979638009049773,
  p_value: {
    insufficient_samples: false,
    p: 2.264178178279508e-9,
    confidence: 0.9999999977358218,
    is_interesting: true
  }
}]];
const getData = (events: string[], properties: string[]) => {
  const data = {
    $overall: Object.fromEntries(["step_conv_ratio", "avg_time_from_start", "count", "overall_conv_ratio", "avg_time"].map(key => [key, Object.fromEntries(events.map((ev, ind) => ["".concat(ind + 1, ". ").concat(ev), {
      all: OVERALL[ind][key]
    }]).filter((_ref: [string, {
      all: any;
    }]) => {
      let [, val]: [string, {
        all: any;
      }] = _ref;
      return !!val.all;
    }))]))
  };
  properties.forEach((prop, propIndex) => {
    data[prop] = Object.fromEntries(["step_conv_ratio", "avg_time_from_start", "count", "overall_conv_ratio", "avg_time"].map(key => [key, Object.fromEntries(events.map((ev, ind) => {
      var _SERIES$ind;
      return ["".concat(ind + 1, ". ").concat(ev), {
        all: (SERIES === null || SERIES === void 0 || (_SERIES$ind = SERIES[ind]) === null || _SERIES$ind === void 0 || (_SERIES$ind = _SERIES$ind[propIndex]) === null || _SERIES$ind === void 0 ? void 0 : _SERIES$ind[key]) || 0
      }];
    }))]));
  });
  return {
    ["".concat(events[0], " through ").concat(events[events.length - 1])]: data
  };
};
const props = (events: string[], property: string, properties: string[], cardTitle?: string) => ({
  cardTitle,
  projectId: "",
  chartOptions: {
    type: "funnel-steps"
  },
  bookmark: {
    dashboard: {},
    params: {
      displayOptions: {
        chartType: ChartType.FunnelSteps,
        plotStyle: ChartPlotStyle.Standard,
        analysis: AnalysisType.Linear,
        value: ValueRepresentationType.Absolute,
        funnelStepsSelectedTableColumns: {
          'conv-first-step': true,
          'conv-prev-step': true,
          count: true,
          'stat-sig': false,
          'time-first-step': true,
          'time-prev-step': true
        }
      },
      sorting: {},
      sections: {
        cohorts: [],
        filter: [],
        formula: [],
        group: [{
          resourceType: InsightsResourceType.Events,
          value: property,
          propertyType: PropertyType.String
        }],
        show: [{
          behavior: {
            type: MetricType.Funnel,
            conversionWindowDuration: 30,
            conversionWindowUnit: "day",
            funnelOrder: FunnelOrder.Loose,
            behaviors: events.map(ev => ({
              type: MetricType.Event,
              name: ev,
              funnelOrder: FunnelOrder.Loose,
              filtersDeterminer: "all",
              filters: []
            }))
          },
          isExpanded: true,
          measurement: {
            math: FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE
          }
        }],
        time: [{
          dateRangeType: "in the last",
          window: {
            unit: "day",
            value: 30
          },
          unit: "day"
        }]
      }
    }
  },
  chartParams: {
    computed_at: "2023-11-21T14:29:51.809133+00:00",
    headers: ["$funnel", property, "Metric", "Step"],
    series: getData(events, properties),
    meta: {
      min_sampling_factor: 1,
      time_period_settings: {
        quarter_start_month: 1
      },
      report_sections: {
        group: [{
          bookmark: {
            dataset: "$mixpanel",
            value: property,
            resourceType: InsightsResourceType.Events,
            search: "",
            propertyType: PropertyType.String
          }
        }],
        show: [{
          metric_key: "".concat(events[0], " through ").concat(events[events.length - 1])
        }]
      }
    }
  },
  dataGroups: null
});
export const FunnelBreakdownPreview = (_ref2: {
  events: string[];
  properties: string[];
  property: string;
  cardTitle?: string;
}) => {
  let {
    events,
    property,
    properties,
    cardTitle
  }: {
    events: string[];
    properties: string[];
    property: string;
    cardTitle?: string;
  } = _ref2;
  //@ts-ignore
  return <CardSnabbdom params={props(events, property, properties, cardTitle)} data-sentry-element="CardSnabbdom" data-sentry-component="FunnelBreakdownPreview" data-sentry-source-file="funnel-breakdown.tsx" />;
};